import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { FcCancel } from "react-icons/fc";
import { BsArrowUpCircle } from "react-icons/bs";
import { TiTick } from "react-icons/ti";

import newContractAbi from "../Services/NewContractAbi.json";
import { ethers } from "ethers";
import { Spinner } from "flowbite-react";
import { useNetwork,useSigner,useAccount } from "wagmi";
const { BigNumber } = require("ethers");


const TransactionRejected = () => {
   

  return (
    <div className=" h-screen md:flex items-center justify-center p-14 lg:p-2 ">
      <div className="w-auto text-center tracking-widest lg:p-24 p-4 pt-8  ml-2  bg-slate-50 shadow-lg h-fit  ">
  
        <center className="mt-4">
          <TiTick color="green" size={200} />
        </center>
        <h1 className="text-2xl mt-4 "> {} {}</h1>
        {/* <p className="text-2xl mt-1">{amount}</p> */}
        <div className=" justify-between text-center text-xl mt-4 mb-2">
          <h1> Token Sent </h1>
          <p className=" text-sm tracking-normal"> {}</p>
        </div>
       
      </div>
    </div>
  );
};

export default TransactionRejected;
